import { createSlice } from '@reduxjs/toolkit'
import { noSpecialChar, valueRangeMaxMin } from '../common/Common'
import provinceData from 'province';

export const loginSlice = createSlice({
    name: "counter",
    initialState: {
        customerInfo: {
            fullName: { value: '', required: true, errorMessage: '', fieldName: 'fullName', label: 'ชื่อ-นามสกุล', placeholder: "ชื่อ-นามสกุล", maxLength: 250 },
            phone: { value: '', required: true, errorMessage: '', fieldName: 'phone', label: 'เบอร์โทรศัพท์', placeholder: "เบอร์โทรศัพท์", maxLength: 10, inputmode: "numeric" },
            email: { value: '', required: true, errorMessage: '', fieldName: 'email', label: 'อีเมล', placeholder: "อีเมล", maxLength: 100 },
            otp: { value: '', required: true, errorMessage: '', fieldName: 'otp', label: 'OTP', placeholder: "กรุณากรอก OTP", maxLength: 10, inputmode: "numeric" },
            otpRef: { value: '' },
            otpID: { value: '' },
            token: { value: '' },
            IsActive: { value: true },
        },
        searchCriteria: {
            customerSubscribeId: { value: '' },
            criteriaName: { value: '', required: true, errorMessage: '', fieldName: 'criteriaName', label: '', placeholder: "กรอกตั้งชื่อการแจ้งเตือน", maxLength: 250 },
            province: {
                value: "", fieldName: "province", placeholderSearch: "ชื่อจังหวัด", placeholder: "จังหวัด", dropdownParent: "#favorite-popup",
                option: []
            },
            district: {
                value: "", fieldName: "district", placeholderSearch: "ชื่อเขต/อำเภอ", placeholder: "เขต/อำเภอ", dropdownParent: "#favorite-popup",
                option: []
            },
            subDistrict: {
                value: "", fieldName: "subDistrict", placeholderSearch: "ชื่อแขวง/ตำบล", placeholder: "แขวง/ตำบล", dropdownParent: "#favorite-popup",
                option: []
            },

            propertyType: {
                value: "", fieldName: "propertyType", errorMessage: '', required: true,
                housetype: { value: false, code: "02", name: "บ้านเดี่ยว", fieldName: "housetype", group: "propertyType" },
                land: { value: false, code: "01", name: "ที่ดิน", fieldName: "land", group: "propertyType" },
                townhouse: { value: false, code: "03", name: "ทาวน์เฮ้าส์", fieldName: "townhouse", group: "propertyType" },
                condo: { value: false, code: "05", name: "คอนโดมิเนียม", fieldName: "condo", group: "propertyType" },
                commercialbuilding: { value: false, code: "04", name: "อาคารพาณิชย์", fieldName: "commercialbuilding", group: "propertyType" },
                warehouse: { value: false, code: "12", name: "โกดัง", fieldName: "warehouse", group: "propertyType" },
                factory: { value: false, code: "09", name: "โรงงาน", fieldName: "factory", group: "propertyType" },
                apartment: { value: false, code: "15", name: "อพาร์ทเม้นท์", fieldName: "apartment", group: "propertyType" },
                office: { value: false, code: "10", name: "อาคารสำนักงาน", fieldName: "office", group: "propertyType" },
                resort: { value: false, code: "20", name: "รีสอร์ท", fieldName: "resort", group: "propertyType" },
                houseother: { value: false, code: "19", name: "อื่น ๆ", fieldName: "houseother", group: "propertyType" },
            },
            rangePrice: {
                value: "", fieldName: "rangePrice", min: 0, max: 11, from: 0, from_value: 0, to: 0, to_value: 0, step: 1, count: 0, placeholder: "ราคาเริ่มต้น - สิ้นสุด",
                values: [
                    "ไม่ระบุ", "1 ล้านบาท", "3 ล้านบาท", "5 ล้านบาท", "10 ล้านบาท", "20 ล้านบาท", "50 ล้านบาท"
                ]
            },
            areaRange: {
                value: "", fieldName: "areaRange", min: 0, max: 8, from: 0, to: 0, step: 1, count: 0, placeholder: "เนื้อที่เริ่มต้น - สิ้นสุด",
                values: [
                    "ไม่ระบุ", "50 ตร.ว.", "100 ตร.ว.", "200 ตร.ว.", "300 ตร.ว.", "1 ไร่", "5 ไร่", "10 ไร่", "50 ไร่"
                ]
            },
            useableAreaRange: {
                value: "", fieldName: "useableAreaRange", min: 0, max: 6, from: 0, to: 0, step: 1, count: 0, placeholder: "พื้นที่เริ่มต้น - สิ้นสุด",
                values: [
                    "ไม่ระบุ", "30 ตร.ม.", "50 ตร.ม.", "100 ตร.ม.", "200 ตร.ม.", "500 ตร.ม.",
                ]
            },
            frequency: { value: 'D' },
        },
        submitFavEnable: {
            value: false
        },
        AutoID: "",
        criteriaList: [],
        loading: null,
    },
    reducers: {
        searchCriteriaDataChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;
            const errorMessage = action.payload.errorMessage;

            state.searchCriteria[field].value = value;

            state.searchCriteria[field].errorMessage = errorMessage;
        },
        searchCriteriaValidateChange: (state, action) => {
            const field = action.payload.field;
            const errorMessage = action.payload.errorMessage;
            state.searchCriteria[field].errorMessage = errorMessage;
        },
        searchCriteriaListChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;

            state.searchCriteria[field].value = "";
            state.searchCriteria[field].option = value;
        },
        searchCriteriaIonRangeChange: (state, action) => {
            const field = action.payload.fieldName;
            const value = action.payload.value;
            const from = action.payload.from;
            const to = action.payload.to;

            state.searchCriteria[field].value = value;
            state.searchCriteria[field].from = state.searchCriteria[field].values.indexOf(from);
            if (to === "MAX") {
                state.searchCriteria[field].to = state.searchCriteria[field].max;
            }
            else {
                state.searchCriteria[field].to = state.searchCriteria[field].values.indexOf(to);
            }
        },
        searchCriteriaIonRangeListChange: (state, action) => {
            const field = action.payload.fieldName;
            const value = action.payload.value;

            state.searchCriteria[field].values = value;
        },
        updateCriteriaIonRange: (state, action) => {
            const field = action.payload.fieldName;

            state.searchCriteria[field].count += 1;
        },
        CheckBoxCriteriaChange: (state, action) => {
            const field = action.payload.fieldName;
            const value = action.payload.value;
            const group = action.payload.group;

            const groupLength = Object.keys(state.searchCriteria[group]).length - 2

            state.searchCriteria[group][field].value = value;

            const temp = Object.entries(state.searchCriteria[group]).map((item) => {
                if (item[0] !== "fieldName" && item[0] !== "value" && item[1].value) {
                    return item[1].code
                }
            }).filter(x => x);

            state.searchCriteria[group].value = temp.length === groupLength ? "" : temp.join(',');
            state.searchCriteria[group].errorMessage = ''
        },
        ClearSearchCriteria: (state, action) => {
            console.log("clear dis")
            Object.keys(state.searchCriteria).forEach(function (key) {
                if (key === "bathroom" || key === "bedroom") {
                    state.searchCriteria[key].value = 0
                } else if (key === "frequency") {
                    state.searchCriteria[key].value = "D"
                } else {
                    state.searchCriteria[key].value = ""
                }
            });

            state.searchCriteria.criteriaName.errorMessage = "";
            state.searchCriteria.propertyType.errorMessage = "";

            state.searchCriteria.propertyType.housetype.value = false
            state.searchCriteria.propertyType.land.value = false
            state.searchCriteria.propertyType.townhouse.value = false
            state.searchCriteria.propertyType.condo.value = false
            state.searchCriteria.propertyType.commercialbuilding.value = false
            state.searchCriteria.propertyType.warehouse.value = false
            state.searchCriteria.propertyType.factory.value = false
            state.searchCriteria.propertyType.apartment.value = false
            state.searchCriteria.propertyType.office.value = false
            state.searchCriteria.propertyType.resort.value = false
            state.searchCriteria.propertyType.houseother.value = false

            state.searchCriteria.rangePrice.from = 0
            state.searchCriteria.rangePrice.to = 0
            state.searchCriteria.rangePrice.count += 1
            state.searchCriteria.areaRange.from = 0
            state.searchCriteria.areaRange.to = 0
            state.searchCriteria.areaRange.count += 1
            state.searchCriteria.useableAreaRange.from = 0
            state.searchCriteria.useableAreaRange.to = 0
            state.searchCriteria.useableAreaRange.count += 1

            state.submitFavEnable.value = false

        },
        addObjToCriteriaList: (state, action) => {
            let customerSubscribeId = { value: action.payload.customerSubscribeId || "" };
            let criteriaName = { value: action.payload?.criteriaName || "" };
            let province = { value: action.payload?.province || "" };
            let district = { value: action.payload?.district || "", option: provinceData.find(x => x.value == province.value)?.child || [] };
            let subDistrict = { value: action.payload?.subDistrict || "", option: district.option.find(x => x.value == district.value)?.child || [] };
            let propertyType = { value: action.payload?.propertyType || "" };
            let rangePrice = { value: action.payload?.rangePrice || "" };
            let areaRange = { value: action.payload?.areaRange || "" };
            let useableAreaRange = { value: action.payload?.useableAreaRange || "" };
            let frequency = { value: action.payload?.frequency || "D" };

            if (propertyType.value) {
                var propertyTypeValueName = propertyType.value.split(",").map((code) => {
                    return Object.keys(state.searchCriteria.propertyType).filter((key) => {
                        return state.searchCriteria.propertyType[key].code === code
                    })[0]
                }).filter((x) => x)

                // console.log("propertyTypeValueName", propertyTypeValueName)

                propertyTypeValueName.map((field) => {
                    propertyType[field] = { value: true };
                })
            }

            if (rangePrice.value) {
                rangePrice.value = rangePrice.value + ""
                const M = 1000000
                let from = rangePrice.value.split(',')[0];
                let to = rangePrice.value.split(',')[1];

                if (from === "0") {
                    from = 'ไม่ระบุ'
                } else {
                    from = (parseFloat(from) / M) + " ล้านบาท"
                }
                if (to) {
                    to = (parseFloat(to) / M) + " ล้านบาท"
                } else {
                    to = 'ไม่ระบุ'
                }

                rangePrice = valueRangeMaxMin("rangePrice", from, to)
                rangePrice.from = state.searchCriteria.rangePrice.values.indexOf(rangePrice.from);
                rangePrice.to = rangePrice.to === "MAX" ?
                    state.searchCriteria.rangePrice.max :
                    state.searchCriteria.rangePrice.values.indexOf(rangePrice.to);
            }
            if (areaRange.value) {
                areaRange.value = areaRange.value + ""
                let from = areaRange.value.split(',')[0];
                let to = areaRange.value.split(',')[1];

                if (from === "0") {
                    from = 'ไม่ระบุ'
                } else {
                    from = parseFloat(from)
                    if (from >= 400) {
                        from = (from / 400) + ' ไร่'
                    } else {
                        from = from + ' ตร.ว.'
                    }
                }
                if (to) {
                    to = parseFloat(to)
                    if (to >= 400) {
                        to = (to / 400) + ' ไร่'
                    } else {
                        to = to + ' ตร.ว.'
                    }
                } else {
                    to = 'ไม่ระบุ'
                }

                areaRange = valueRangeMaxMin("areaRange", from, to)
                areaRange.from = state.searchCriteria.areaRange.values.indexOf(areaRange.from);
                areaRange.to = areaRange.to === "MAX" ?
                    state.searchCriteria.areaRange.max :
                    state.searchCriteria.areaRange.values.indexOf(areaRange.to);
            }
            if (useableAreaRange.value) {
                useableAreaRange.value = useableAreaRange.value + ""
                let from = useableAreaRange.value.split(',')[0];
                let to = useableAreaRange.value.split(',')[1];

                if (from === "0") {
                    from = 'ไม่ระบุ'
                } else {
                    from = parseFloat(from) + " ตร.ม."
                }
                if (to) {
                    to = parseFloat(to) + " ตร.ม."
                } else {
                    to = 'ไม่ระบุ'
                }

                useableAreaRange = valueRangeMaxMin("useableAreaRange", from, to)
                useableAreaRange.from = state.searchCriteria.useableAreaRange.values.indexOf(useableAreaRange.from);
                useableAreaRange.to = useableAreaRange.to === "MAX" ?
                    state.searchCriteria.useableAreaRange.max :
                    state.searchCriteria.useableAreaRange.values.indexOf(useableAreaRange.to);
            }

            const obj = {
                customerSubscribeId: customerSubscribeId,
                criteriaName: criteriaName,
                province: province,
                district: district,
                subDistrict: subDistrict,
                propertyType: propertyType,
                rangePrice: rangePrice,
                areaRange: areaRange,
                useableAreaRange: useableAreaRange,
                frequency: frequency,
            };
            state.criteriaList = [...state.criteriaList.filter(x => x.customerSubscribeId.value != customerSubscribeId.value), obj];
        },
        removeObjInCriteriaList: (state, action) => {
            const index = action.payload.index;

            if (index > -1) {
                state.criteriaList.splice(index, 1);
            }
        },
        fillFromObjCriteriaList: (state, action) => {
            const index = action.payload.index;

            Object.keys(state.searchCriteria).forEach((key) => {
                if (key != "propertyType") {
                    Object.assign(state.searchCriteria[key], state.criteriaList[index][key]);
                } else {
                    Object.keys(state.criteriaList[index][key]).forEach((keyCheckBox) => {
                        if (typeof state.criteriaList[index][key][keyCheckBox] === 'object') {
                            Object.assign(state.searchCriteria[key][keyCheckBox], state.criteriaList[index][key][keyCheckBox]);
                        } else {
                            state.searchCriteria[key][keyCheckBox] = state.criteriaList[index][key][keyCheckBox];
                        }

                    })
                }

                if (["rangePrice", "areaRange", "useableAreaRange"].includes(key)) {
                    state.searchCriteria[key].count += 1;
                }
            })
        },
        searchCriteriaValidate: (state, action) => {
            if (state.searchCriteria.criteriaName.value &&
                state.searchCriteria.propertyType.value &&
                state.searchCriteria.frequency.value) {
                state.submitFavEnable.value = true
            } else {
                state.submitFavEnable.value = false
            }
        },
        formsCusInfoDataChange: (state, action) => {
            const field = action.payload.field;
            const value = action.payload.value;
            const errorMessage = action.payload.errorMessage;
            if (state.customerInfo[field].maxLength) {
                state.customerInfo[field].value = value.slice(0, state.customerInfo[field].maxLength);
            } else {
                state.customerInfo[field].value = value;
            }

            state.customerInfo[field].errorMessage = errorMessage;
        },
        ClearCusInfo: (state, action) => {
            Object.keys(state.customerInfo).forEach(function (key) {
                if (key === "bathroom" || key === "bedroom") {
                    state.customerInfo[key].value = 0
                } else if (key === "order") {
                    // state.customerInfo[key].value = "new"
                } else {
                    state.customerInfo[key].value = ""
                }
            });
        },
    },
})

// Action creators are generated for each case reducer function
export const { searchCriteriaDataChange, searchCriteriaListChange, searchCriteriaIonRangeChange, searchCriteriaIonRangeListChange, updateCriteriaIonRange, CheckBoxCriteriaChange, ClearSearchCriteria,
    addObjToCriteriaList, fillFromObjCriteriaList, searchCriteriaValidateChange, removeObjInCriteriaList, searchCriteriaValidate,
    formsCusInfoDataChange, ClearCusInfo,
} = loginSlice.actions

export default loginSlice.reducer